const axios = require('axios');

import {
	serverUrl,
	presighnedUrl
} from '../properties'
const dataUrl = serverUrl;

export default {
	namespaced:true,
	state:{
		notesList:[],
		pathBeforeReleaseNote:''
	},
	mutations:{
		setNotesList:(state, data) => {
			state.notesList  = data;
		},
	},
	getters:{},
	actions:{
		addNote:({commit, state, getters, rootGetters, rootState}, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url: dataUrl + '/release/add',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getList:({commit, state, getters, rootGetters, rootState}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/release/list',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					commit("setNotesList", response.data)
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getNoteById:({commit, state, getters, rootGetters, rootState}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/release/get',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
	}
}
